'use strict';

var debounce = require('lodash/debounce');
var SEARCH_FIELD_SELECTOR = 'input.search-field';
var SUGGESTIONS_ITEM_SELECTOR = '.suggestions .item';
var SUGGESTIONS_SELECTOR = '.suggestions';
var SUGGESTIONS_WRAPPER_SELECTOR = '.suggestions-wrapper';
var ARIA_ACTIVEDESCENDANT = 'aria-activedescendant';
var ARIA_SELECTED = 'aria-selected';
var D_SM_BLOCK = 'd-sm-block';
var RESET_BUTTON_SELECTOR = '.reset-button';
var minChars = 1;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;
var endpoint = $(SUGGESTIONS_WRAPPER_SELECTOR).data('url');

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).closest('.site-search').find(SUGGESTIONS_WRAPPER_SELECTOR);
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length;
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $('body').removeClass('modal-open');
    $('header').siblings().attr('aria-hidden', 'false');
    $(SUGGESTIONS_SELECTOR).removeClass('modal');
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $('body').addClass('modal-open');
        $('header').siblings().attr('aria-hidden', 'true');
        getSuggestionsWrapper(scope).find(SUGGESTIONS_SELECTOR).addClass('modal');
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $(SEARCH_FIELD_SELECTOR).val('');
    clearModals();
    $('.search-mobile ' + SUGGESTIONS_SELECTOR).unbind('scroll');
    $(SUGGESTIONS_WRAPPER_SELECTOR).empty();
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile button.';
    var iconSearch = 'fa-search';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr('type', 'button');
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr('type', 'submit');
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find(SUGGESTIONS_SELECTOR);
        $suggestions.css('top', top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    $.spinner().stop();

    if (typeof (response) !== 'object') {
        $suggestionsWrapper.append(response).show();
        $(this).siblings(RESET_BUTTON_SELECTOR).addClass(D_SM_BLOCK);
        positionSuggestions(this);

        if (isMobileSearch(this)) {
            toggleSuggestionsIcon('close');
            applyModals(this);
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $(SUGGESTIONS_ITEM_SELECTOR);
        if ($(suggestionsList).length) {
            $(SEARCH_FIELD_SELECTOR).attr('aria-describedby', 'search-result-count');
        } else {
            $(SEARCH_FIELD_SELECTOR).removeAttr('aria-describedby');
        }
    } else {
        $suggestionsWrapper.hide();
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    if ($(scope).val().length >= minChars) {
        $.spinner().start();
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        toggleSuggestionsIcon('search');
        $(scope).siblings(RESET_BUTTON_SELECTOR).removeClass(D_SM_BLOCK);
        clearModals();
        getSuggestionsWrapper(scope).empty();
    }
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var suggestionsList = $(SUGGESTIONS_ITEM_SELECTOR);
    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
        $(SEARCH_FIELD_SELECTOR).each(function () {
            $(this).attr(ARIA_ACTIVEDESCENDANT, suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).removeAttr(ARIA_SELECTED);
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass('selected');
                    suggestionsList.eq(idx).attr(ARIA_SELECTED, true);
                    $(this).removeProp(ARIA_SELECTED);
                    $(SEARCH_FIELD_SELECTOR).each(function () {
                        $(this).attr(ARIA_ACTIVEDESCENDANT, suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass('selected');
                    suggestionsList.first().attr(ARIA_SELECTED, true);
                    $(SEARCH_FIELD_SELECTOR).each(function () {
                        $(this).attr(ARIA_ACTIVEDESCENDANT, suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

module.exports = function () {
    $('form[name="simpleSearch"]').submit(function (e) {
        var suggestionsList = $(SUGGESTIONS_ITEM_SELECTOR);
        if (suggestionsList.filter('.selected').length !== 0) {
            e.preventDefault();
            suggestionsList.filter('.selected').find('a')[0].click();
        }
    });

    $(SEARCH_FIELD_SELECTOR).each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 300);
        $(this).on('keyup focus', function (e) {
            // Capture Down/Up Arrow Key Events
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                default:
                    debounceSuggestions(this, e);
            }
        });
    });

    $('body').on('click', function (e) {
        if (!$(SUGGESTIONS_SELECTOR).has(e.target).length && !$(e.target).hasClass('search-field')) {
            $(SUGGESTIONS_SELECTOR).hide();
        }
    });

    $('body').on('click touchend', '.search-mobile button.fa-close', function (e) {
        e.preventDefault();
        $(SUGGESTIONS_SELECTOR).hide();
        toggleSuggestionsIcon('search');
        tearDownSuggestions();
    });

    $('body').on('click', '.site-search ' + RESET_BUTTON_SELECTOR, function () {
        const $this = $(this);
        $this.removeClass(D_SM_BLOCK);
        $this.siblings('.search-field').val('');
    });

    $('body').on('click touchstart', '[name="search-button"]', function () {
        $(this).closest('form').submit();
    });
};
